import { render, staticRenderFns } from "./aftersale_visit_service_detail.vue?vue&type=template&id=3adbaa38&scoped=true"
import script from "./aftersale_visit_service_detail.vue?vue&type=script&lang=js"
export * from "./aftersale_visit_service_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adbaa38",
  null
  
)

export default component.exports